import ApiClient, {
  ApiResponse,
  ForbiddenError,
  NotFoundError,
  UnauthorizedError,
  UnexpectedError,
} from "../../helpers/api";
import { useQuery } from "react-query";
import { Section } from "../../domains/Section";
import { shouldRetryApiQuery } from "./shouldRetryApiQuery";

type UseSectionsApi = {
  enabled: boolean;
};
type SectionsResponse = {
  sectionOperatorInvitations: ReadonlyArray<Section>;
  sections: ApiResponse<ReadonlyArray<Section>>;
};
export const useSectionsApi = (options?: UseSectionsApi) => {
  const path = "/api/v1/sections";
  return useQuery<ReadonlyArray<Section>, UnexpectedError>(
    path,
    async () => {
      const res = await ApiClient.get(path);
      if (res.ok) {
        const json = (await res.json()) as SectionsResponse;
        return json.sections.data;
      } else if (res.status === 401) {
        throw new UnauthorizedError();
      } else if (res.status === 403) {
        // 403は認可・IP制限など再ログインでは解消しないため ForbiddenError として区別する
        throw new ForbiddenError();
      } else if (res.status === 404) {
        // 存在しない・無効なURLのため NotFoundError として区別する
        throw new NotFoundError();
      }
      throw new UnexpectedError();
    },
    {
      enabled: options?.enabled,
      retry: shouldRetryApiQuery,
    },
  );
};
